import { last } from 'lodash-es'

// TODO: make this somewhere on the backend ?
// from identifier (ex : "segment-3507")
// we need to extract the ID (ex : 3507)
export default function identifierToId(identifier: string): number | null {
  const idAsStr = last(identifier.split('-'))
  return idAsStr ? parseInt(idAsStr) : null
}
